export default class GlobalHelper {
  static clearStorageWithoutLanguage() {
    const language = localStorage.getItem('language') || 'en';
    const storedFilters = localStorage.getItem('customDashboardFilters');

    localStorage.clear();

    localStorage.setItem('language', language);
    localStorage.setItem('customDashboardFilters', storedFilters);
  }

  static saveToLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  }

  static loadFromLocalStorage(key) {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }

  static removeFromLocalStorage(key) {
    localStorage.removeItem(key);
  }

  static storeCustomDashboardFilters(params) {
    if (!params || !params.dashboardId) {
      return;
    }
    let storedFilters = {};
    const item = this.safeParse('customDashboardFilters', {});
    if (Object.keys(item)?.length > 0) {
      storedFilters = item;
    }

    storedFilters[params.dashboardId] = params;
    localStorage.setItem('customDashboardFilters', JSON.stringify(storedFilters));
  }

  static getLocalStoredDashboardFilters(dashboardId) {
    try {
      const storedFilters = this.safeParse('customDashboardFilters', {});

      if (typeof storedFilters !== 'object' || storedFilters === null) {
        return {};
      }

      return storedFilters[dashboardId] || {};
    } catch (error) {
      return {};
    }
  }

  static formatFilter = (items, type) => {
    if (!items || !Array.isArray(items)) return [];
    const key = type === 'entity' ? 'entity_name' : 'department_name';
    return items.map((item) => ({ [key]: item }));
  };

  static isSeriesEmptyOrZero(chartOptions) {
    return chartOptions?.series?.every((value) => {
      return !value || value === 0;
    });
  }

  static generateDashboardName(username) {
    const now = new Date();
    const formattedDate = now.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });

    const formattedUsername = username.replace(/_/g, ' ');

    // Format the time as HH:mm:ss for uniqueness
    const time = now.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });

    return `${formattedUsername} Dashboard - ${formattedDate} - ${time}`;
  }

  static safeParse = (key, defaultValue = null) => {
    try {
      return JSON.parse(localStorage.getItem(key)) || defaultValue;
    } catch {
      return defaultValue;
    }
  };

  static calculateInputTitleWidth = (title, px, minWidth, iconWidth, space) => {
    if (!title) return minWidth;

    const span = document.createElement('span');
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.style.top = '-9999px';
    span.style.left = '-9999px';
    span.style.whiteSpace = 'pre';
    span.style.fontFamily = 'ClashDisplay-Semibold, sans-serif';
    span.style.fontSize = `${px}px`;
    span.style.fontWeight = '600';
    span.style.letterSpacing = '0px';
    span.style.lineHeight = '1';
    span.style.padding = '0px';
    span.style.margin = '0px';
    span.style.border = 'none';
    span.style.outline = 'none';
    span.style.boxSizing = 'content-box';

    span.textContent = title;

    document.body.appendChild(span);
    const textWidth = span.getBoundingClientRect().width;
    document.body.removeChild(span);

    const totalWidth = Math.max(textWidth, minWidth) + iconWidth + space;

    return totalWidth;
  };

  static containsFilledAttributes = (obj) => {
    return Object.values(obj).some((value) => value && Object.keys(value).length > 0);
  };

  static normalizeWhitespace = (str) => {
    return str.trim().replace(/\s+/g, ' ');
  };

  static getCustomAttributes = () => {
    const raw = localStorage.getItem('custom-attributes');
    if (!raw || raw === 'undefined') return [];
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
      if (parsed && typeof parsed === 'object') return Object.keys(parsed);
      return [];
    } catch {
      return [];
    }
  };

  static getDummyProfileImage = (genderId, index) =>
    `https://randomuser.me/api/portraits/${genderId === 'F' ? 'women' : 'men'}/${index + 1}.jpg`;

  static formatTimestamp = (timestamp) => {
    if (!timestamp) return 'Unknown time';

    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = Math.abs(now - date);
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMinutes < 1) return 'Just now';
    if (diffMinutes < 60) return `${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays === 1) return 'Yesterday';
    if (diffDays <= 7) return `${diffDays} days ago`;

    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
}
